import axios from 'axios'

const baseUrl = process.env.VUE_APP_API_ENDPOINT

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

/**
 * Check if an email already exists via the API.
 * Returns { proceed: true } if the user can continue,
 * or { proceed: false, reason: '...', ... } if blocked.
 * On any API error, returns { proceed: true } so the user is never blocked by a failure.
 */
export async function checkEmail(email) {
  if (!email || !EMAIL_REGEX.test(email)) {
    return { proceed: true }
  }

  try {
    const response = await axios.post(`${baseUrl}/api/check-email`, {
      email: email.toLowerCase().trim()
    })

    const { email_found, paid_user, user_role } = response.data

    if (!email_found) {
      return { proceed: true }
    }

    // Found but role is not USER — block
    if (user_role && user_role !== 'USER') {
      return { proceed: false, reason: 'wrong_role', role: user_role }
    }

    // Found, is USER, and has paid — block
    if (paid_user) {
      return { proceed: false, reason: 'paid_user' }
    }

    // Found, is USER, not paid — allow
    return { proceed: true }
  } catch (error) {
    // Never block on API failure
    console.error('Email check failed:', error)
    return { proceed: true }
  }
}
